import { ShareNetworkIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Share = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <ShareNetworkIcon size={Sizes[size]} color={fill || stroke} {...rest} />;
};

Share.displayName = 'Share';
